// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DocumentModel } from './documentModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class DocumentsV1GeneratePdfFromHtmlSaveSuccessResponse {
    'data': DocumentModel | null;
    'success': boolean;
    'messages': Array<string> | null;

    static discriminator = "success" as const;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DocumentsV1GeneratePdfFromHtmlSaveSuccessResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "DocumentModel"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return DocumentsV1GeneratePdfFromHtmlSaveSuccessResponse.attributeTypeMap;
    }
}
